export const classColorsMap = {
    green: 'status-ok',
    red: 'status-error',
    gray: 'status-unmonitored',
    yellow: 'status-minor',
    orange: 'status-warning',
};

